import { IHttpService, IPromise, IQService } from 'angular';
import { GmcApi } from '../../constants/gmc-api';
import { TableContact } from './table-contact';
import { ITableEmployerData, TableEmployer } from './employer.interface';
import { ApiService } from '../api-service/api.service';
import { EmployerProfile } from '../../entities/employer-profile';
import { IUserProfile } from '../../entities/profile';
import { CompanyData, ICompanyData } from '../../entities/company-data';
import { EmployerPersonalData } from '../../entities/employer-personal-data';
import { EmployerInfo, IEmployerInfo } from '../../entities/employer-info';
import { IUploadFileResult } from '../../interfaces/upload-file-response.interface';
import { isObject } from 'lodash-es';

export class EmployerService {
  static $inject = [
    '$http',
    'GmcApi',
    'ApiService',
    '$q'
  ];

  constructor( private $http: IHttpService,
               private gmcApi: GmcApi,
               private apiService: ApiService,
               private $q: IQService ) {
  }

  getContacts( params: object ): IPromise<any> {
    return this.$http.get<any>(this.gmcApi.employer.getContacts, { params })
      .then(( res ) => {
        return {
          count: res.data.count,
          pages: res.data.pages,
          contacts: res.data.data.map(( item ) => new TableContact(item))
        };
      })
      .catch(( err ) => {
        throw new Error(err.data ? err.data.error : 'Error');
      });
  }

  getEmployerCount( params: object ): IPromise<ITableEmployerData> {
    return this.$http.get<any>(this.gmcApi.employer.top, { params })
      .then(( res ) => {
        return res.data.count;
      });
  }

  getTopEmployers( params: object ): IPromise<ITableEmployerData> {
    return this.$http.get<any>(this.gmcApi.employer.top, { params })
      .then(( res ) => {
        console.log(res);

        return res.data;
      });
  }

  getTopEmployersPublic( params: object ): IPromise<ITableEmployerData> {
    return this.$http.get<any>(this.gmcApi.user.getAllEmployersLight, { params })
      .then(( res ) => {
        return res.data;
      });
  }

  getEmployerInfo( employerId: string ): IPromise<any> {
    return this.apiService.get<{ data: IEmployerInfo }>(`/user/getEmployerInfo/${employerId}`)
      .then(( { data } ) => {
        // return new EmployerInfo(res)
        const employerInfo = new EmployerInfo(data);
        return employerInfo;
      });
  }

  checkEmployer( employerId: string ): IPromise<boolean> {
    return this.apiService.get<{ data: IEmployerInfo }>(`/user/getEmployerInfo/${employerId}`)
      .then(() => {
        return true;
      });
  }

  getEmployerProfile(): IPromise<EmployerProfile> {
    return this.$q.all([
      this.apiService.get('/user/getMyProfile')
    ])
      .then(( [ personalData ] ) => {
        return new EmployerProfile(personalData, personalData.employer_company);
      });
  }

  updateEmployerProfile( data: EmployerProfile ): IPromise<any> {
    const update = {
      personal_info: {
        ...data
      }
    };
    return this.apiService.post('/user/updateBasicProfile', update);
  }

  updatePersonalInfo( data: EmployerPersonalData ): IPromise<any> {
    const update = {
      personal_info: data
    };
    return this.apiService.post('/user/updateBasicProfile', update);
  }

  updateCompanyInfo( data: CompanyData ): IPromise<any> {
    const update = {
      company_data: data
    };
    return this.apiService.post('/user/updateMyProfileCompanyData', update);
  }

  // updateCompanyLogo( file: File ): IPromise<any> {
  //   // return
  // }
}



// WEBPACK FOOTER //
// ./app/core/services/employer/employer.service.ts